
import { Options, Vue } from 'vue-property-decorator';
import NLoadingCircle from '@/uikit/loading/NLoadingCircle.vue';

@Options({
  components: { NLoadingCircle }
})
export default class VideoWallPlayerLoader extends Vue {}
